<template>
  <ViewTemplate
    :heroContent="heroContent"
    :tocSections="tocSections"
    :keyMetrics="keyMetrics"
    :challengeContent="challengeContent"
    :solutionContent="solutionContent"
    :resultsContent="resultsContent"
    :impactContent="impactContent"
    :talentTestimonialContent="talentTestimonialContent"
    :customerTestimonialContent="customerTestimonialContent"
    :currentStoryId="currentStoryId"
    :stories="stories"
  />
</template>

<script setup>
import ViewTemplate from './Components/ViewTemplate.vue';
import { anthropic } from './anthropic.js';

const {
  currentStoryId,
  stories,
  heroContent,
  tocSections,
  keyMetrics,
  challengeContent,
  solutionContent,
  resultsContent,
  impactContent,
  talentTestimonialContent,
  customerTestimonialContent,
} = anthropic;
</script>
